module.exports = __webpack_public_path__ + "static/LRAplinkosMin-6b5ff8063b03c8b4465e94ba59bae68f.png";